import axios from 'axios';
import { message } from 'antd';

const api = axios.create({
  baseURL: '/api',
  timeout: 300000
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log('API Request:', config.method.toUpperCase(), config.url, config);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.config.url, response.status, response.data);
    return response;
  },
  (error) => {
    console.error('API Response Error:', error.config?.url, error.response?.status, error);
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem('token');
        message.error('登录已过期，请重新登录');
        window.location.href = '/login';
      } else if (error.response.status === 403) {
        message.error('没有权限访问');
      } else if (error.response.status === 500) {
        message.error('服务器错误，请稍后重试');
      }
    } else if (error.request) {
      message.error('网络连接失败，请检查网络');
    }
    return Promise.reject(error);
  }
);

export default api;
